<dx-popup
    [title]="'Invoices for ' + arTotal.Name"
    [width]="1000"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item
        widget="dxButton"
        location="after"
        [options]="{ text: 'Close', type: 'success', onClick: close }"
    ></dxi-popup-toolbar-item>
    <div class="d-flex flex-fill">
        <dx-data-grid #dataGrid [dataSource]="arTotal.Invoices" keyExpr="Id" class="d-flex flex-fill" height="400">
            <dxi-data-grid-column dataField="Id" width="75"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="InvoiceNumber" caption="Invoice #" width="75"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="Rental" width="75"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="Status" width="75"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="Total" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="Balance" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="due"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="Customer"></dxi-data-grid-column>

            <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
            <dxo-data-grid-selection mode="single"></dxo-data-grid-selection>
        </dx-data-grid>
    </div>
</dx-popup>
